import type { StockFeedVibeFile, VenueVibe } from "@/lib/generated/stockFeedVibe";

export type { VenueVibe };

let cache: StockFeedVibeFile | null = null;
let loading: Promise<StockFeedVibeFile> | null = null;

/** Lazy-load vibe map into its own chunk (not in the main Discovery bundle). */
export async function ensureStockFeedVibe(): Promise<StockFeedVibeFile> {
  if (cache) return cache;
  loading ??= import("@/lib/generated/stockFeedVibe").then((m) => {
    cache = m.STOCK_FEED_VIBE;
    return cache;
  });
  return loading;
}

/** Stock-assigned vibe for feed badges; undefined when no mapping exists. */
export function stockVibeForVenue(venueId: string): VenueVibe | undefined {
  return cache?.venues[venueId];
}
